<template>
  <WizardContent
    :show-sidebar="false"
    class="wizard-wrapper"
  >
    <GateHeader>
      <template #logo>
        <JobNavIcon />
      </template>
      <template #page-title>
        Welcome back to JobNav!
      </template>
      <template #below-title>
        Don't have an account yet?
        <router-link
          to="signup"
        >
          Sign up now
        </router-link>
      </template>
    </GateHeader>
    <div class="mt-1">
      <p class="text-body-1 text-textDarkest mt-5">
        If the email is taking too long to show up in your inbox, check your spam folder.
      </p>
    </div>
  </WizardContent>
</template>

<script>
import { mapActions } from 'pinia';
import WizardContent from '@/components/shared/WizardContent.vue';
import GateHeader from '@/components/shared/gates/GateHeader.vue';
import { useWizard } from '@/stores/wizard/wizard';
import JobNavIcon from '@/assets/jobnav-payscale-icon-logo.svg?component';

export default {
  name: 'PasswordResetSuccess',
  components: {
    WizardContent,
    GateHeader,
    JobNavIcon,
  },
  emits: ['track-page-load'],
  data() {
    return {
      email: this.$route.query.email || '',
    };
  },
  created() {
    if (!this.email) {
      this.$router.push({
        name: 'password-reset',
      });
    }
  },
  mounted() {
    this.updateFlash({ status: 'success', message: 'Email sent! Please check and confirm.' });
  },
  beforeCreate() {
    this.$emit('track-page-load', { page: 'Password Reset Success' });
  },
  methods: {
    ...mapActions(useWizard, ['updateFlash', 'resetFlash']),
  },
};
</script>

<style scoped>
.wizard-wrapper {
  min-width: 330px;
  width: 100%;
  align-items: center;
  justify-content: center;
}

:deep(.wizard-flash-message) {
  border-top-right-radius: 0px !important;
}

:deep(.slot-flash-message.full-width) {
  width: 450px;
}
</style>
